export default __webpack_public_path__ + "static/media/ic_show_Nav.ba1e1272.svg";